// source: gw/servicepr/dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var domain_enumeration_service_pr_payment_type_pb = require('../../domain/enumeration/service_pr_payment_type_pb.js');
goog.object.extend(proto, domain_enumeration_service_pr_payment_type_pb);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.DisableReason', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetDashboardRequest', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetDashboardResponse', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.PaymentInfo', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.PublishingInfo', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.PublishingStatus', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.ScreeningInfo', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.ServiceInfo', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.ServiceSummary', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.ServicesStatus', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.Summary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.displayName = 'proto.coconala.protobuf.gw.servicepr.GetDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.repeatedFields_, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetDashboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.displayName = 'proto.coconala.protobuf.gw.servicepr.GetDashboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.PaymentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.PaymentInfo.displayName = 'proto.coconala.protobuf.gw.servicepr.PaymentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.Summary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.Summary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.Summary.displayName = 'proto.coconala.protobuf.gw.servicepr.Summary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.ServiceSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.ServiceSummary.displayName = 'proto.coconala.protobuf.gw.servicepr.ServiceSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.ServiceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.ServiceInfo.displayName = 'proto.coconala.protobuf.gw.servicepr.ServiceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.PublishingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.PublishingInfo.displayName = 'proto.coconala.protobuf.gw.servicepr.PublishingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.ScreeningInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.ScreeningInfo.displayName = 'proto.coconala.protobuf.gw.servicepr.ScreeningInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.displayName = 'proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.displayName = 'proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetDashboardRequest;
  return proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue start_date = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue end_date = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardRequest} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    startDateLimit: (f = msg.getStartDateLimit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    totalSummary: (f = msg.getTotalSummary()) && proto.coconala.protobuf.gw.servicepr.Summary.toObject(includeInstance, f),
    serviceSummariesList: jspb.Message.toObjectList(msg.getServiceSummariesList(),
    proto.coconala.protobuf.gw.servicepr.ServiceSummary.toObject, includeInstance),
    paymentInfo: (f = msg.getPaymentInfo()) && proto.coconala.protobuf.gw.servicepr.PaymentInfo.toObject(includeInstance, f),
    screeningInfo: (f = msg.getScreeningInfo()) && proto.coconala.protobuf.gw.servicepr.ScreeningInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetDashboardResponse;
  return proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStartDateLimit(value);
      break;
    case 4:
      var value = new proto.coconala.protobuf.gw.servicepr.Summary;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.Summary.deserializeBinaryFromReader);
      msg.setTotalSummary(value);
      break;
    case 5:
      var value = new proto.coconala.protobuf.gw.servicepr.ServiceSummary;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.ServiceSummary.deserializeBinaryFromReader);
      msg.addServiceSummaries(value);
      break;
    case 6:
      var value = new proto.coconala.protobuf.gw.servicepr.PaymentInfo;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.PaymentInfo.deserializeBinaryFromReader);
      msg.setPaymentInfo(value);
      break;
    case 7:
      var value = new proto.coconala.protobuf.gw.servicepr.ScreeningInfo;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.ScreeningInfo.deserializeBinaryFromReader);
      msg.setScreeningInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStartDateLimit();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTotalSummary();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.coconala.protobuf.gw.servicepr.Summary.serializeBinaryToWriter
    );
  }
  f = message.getServiceSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.coconala.protobuf.gw.servicepr.ServiceSummary.serializeBinaryToWriter
    );
  }
  f = message.getPaymentInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.coconala.protobuf.gw.servicepr.PaymentInfo.serializeBinaryToWriter
    );
  }
  f = message.getScreeningInfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.coconala.protobuf.gw.servicepr.ScreeningInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue start_date = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue end_date = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue start_date_limit = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getStartDateLimit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setStartDateLimit = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearStartDateLimit = function() {
  return this.setStartDateLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasStartDateLimit = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Summary total_summary = 4;
 * @return {?proto.coconala.protobuf.gw.servicepr.Summary}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getTotalSummary = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.Summary} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.Summary, 4));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.Summary|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setTotalSummary = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearTotalSummary = function() {
  return this.setTotalSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasTotalSummary = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated ServiceSummary service_summaries = 5;
 * @return {!Array<!proto.coconala.protobuf.gw.servicepr.ServiceSummary>}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getServiceSummariesList = function() {
  return /** @type{!Array<!proto.coconala.protobuf.gw.servicepr.ServiceSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.coconala.protobuf.gw.servicepr.ServiceSummary, 5));
};


/**
 * @param {!Array<!proto.coconala.protobuf.gw.servicepr.ServiceSummary>} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setServiceSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.addServiceSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.coconala.protobuf.gw.servicepr.ServiceSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearServiceSummariesList = function() {
  return this.setServiceSummariesList([]);
};


/**
 * optional PaymentInfo payment_info = 6;
 * @return {?proto.coconala.protobuf.gw.servicepr.PaymentInfo}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getPaymentInfo = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.PaymentInfo} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.PaymentInfo, 6));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.PaymentInfo|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setPaymentInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearPaymentInfo = function() {
  return this.setPaymentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasPaymentInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ScreeningInfo screening_info = 7;
 * @return {?proto.coconala.protobuf.gw.servicepr.ScreeningInfo}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.getScreeningInfo = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.ScreeningInfo} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.ScreeningInfo, 7));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.ScreeningInfo|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.setScreeningInfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.clearScreeningInfo = function() {
  return this.setScreeningInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardResponse.prototype.hasScreeningInfo = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.PaymentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    dailyBudget: (f = msg.getDailyBudget()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    paymentType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: (f = msg.getAmount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.PaymentInfo;
  return proto.coconala.protobuf.gw.servicepr.PaymentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setDailyBudget(value);
      break;
    case 2:
      var value = /** @type {!proto.coconala.protobuf.domain.enumeration.ServicePrPaymentType} */ (reader.readEnum());
      msg.setPaymentType(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.PaymentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyBudget();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getPaymentType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value daily_budget = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.getDailyBudget = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.setDailyBudget = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.clearDailyBudget = function() {
  return this.setDailyBudget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.hasDailyBudget = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional coconala.protobuf.domain.enumeration.ServicePrPaymentType payment_type = 2;
 * @return {!proto.coconala.protobuf.domain.enumeration.ServicePrPaymentType}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.getPaymentType = function() {
  return /** @type {!proto.coconala.protobuf.domain.enumeration.ServicePrPaymentType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.coconala.protobuf.domain.enumeration.ServicePrPaymentType} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.setPaymentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value amount = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.getAmount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.PaymentInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.PaymentInfo.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.Summary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.Summary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.Summary.toObject = function(includeInstance, msg) {
  var f, obj = {
    impressionCount: (f = msg.getImpressionCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    clickCount: (f = msg.getClickCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    clickRate: (f = msg.getClickRate()) && google_protobuf_wrappers_pb.FloatValue.toObject(includeInstance, f),
    cost: (f = msg.getCost()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    conversionCount: (f = msg.getConversionCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    conversionSales: (f = msg.getConversionSales()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary}
 */
proto.coconala.protobuf.gw.servicepr.Summary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.Summary;
  return proto.coconala.protobuf.gw.servicepr.Summary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.Summary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary}
 */
proto.coconala.protobuf.gw.servicepr.Summary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setImpressionCount(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setClickCount(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.FloatValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.FloatValue.deserializeBinaryFromReader);
      msg.setClickRate(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setCost(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setConversionCount(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setConversionSales(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.Summary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.Summary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.Summary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImpressionCount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getClickCount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getClickRate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.FloatValue.serializeBinaryToWriter
    );
  }
  f = message.getCost();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getConversionCount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getConversionSales();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value impression_count = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getImpressionCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setImpressionCount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearImpressionCount = function() {
  return this.setImpressionCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasImpressionCount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value click_count = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getClickCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setClickCount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearClickCount = function() {
  return this.setClickCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasClickCount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FloatValue click_rate = 3;
 * @return {?proto.google.protobuf.FloatValue}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getClickRate = function() {
  return /** @type{?proto.google.protobuf.FloatValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.FloatValue, 3));
};


/**
 * @param {?proto.google.protobuf.FloatValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setClickRate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearClickRate = function() {
  return this.setClickRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasClickRate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value cost = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getCost = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setCost = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearCost = function() {
  return this.setCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasCost = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value conversion_count = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getConversionCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setConversionCount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearConversionCount = function() {
  return this.setConversionCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasConversionCount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int32Value conversion_sales = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.getConversionSales = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
*/
proto.coconala.protobuf.gw.servicepr.Summary.prototype.setConversionSales = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.Summary} returns this
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.clearConversionSales = function() {
  return this.setConversionSales(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.Summary.prototype.hasConversionSales = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.ServiceSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceInfo: (f = msg.getServiceInfo()) && proto.coconala.protobuf.gw.servicepr.ServiceInfo.toObject(includeInstance, f),
    publishingInfo: (f = msg.getPublishingInfo()) && proto.coconala.protobuf.gw.servicepr.PublishingInfo.toObject(includeInstance, f),
    cpc: (f = msg.getCpc()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    summary: (f = msg.getSummary()) && proto.coconala.protobuf.gw.servicepr.Summary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.ServiceSummary;
  return proto.coconala.protobuf.gw.servicepr.ServiceSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.coconala.protobuf.gw.servicepr.ServiceInfo;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.ServiceInfo.deserializeBinaryFromReader);
      msg.setServiceInfo(value);
      break;
    case 2:
      var value = new proto.coconala.protobuf.gw.servicepr.PublishingInfo;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.PublishingInfo.deserializeBinaryFromReader);
      msg.setPublishingInfo(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setCpc(value);
      break;
    case 4:
      var value = new proto.coconala.protobuf.gw.servicepr.Summary;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.Summary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.ServiceSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.coconala.protobuf.gw.servicepr.ServiceInfo.serializeBinaryToWriter
    );
  }
  f = message.getPublishingInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.coconala.protobuf.gw.servicepr.PublishingInfo.serializeBinaryToWriter
    );
  }
  f = message.getCpc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.coconala.protobuf.gw.servicepr.Summary.serializeBinaryToWriter
    );
  }
};


/**
 * optional ServiceInfo service_info = 1;
 * @return {?proto.coconala.protobuf.gw.servicepr.ServiceInfo}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.getServiceInfo = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.ServiceInfo} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.ServiceInfo, 1));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.ServiceInfo|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.setServiceInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.clearServiceInfo = function() {
  return this.setServiceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.hasServiceInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PublishingInfo publishing_info = 2;
 * @return {?proto.coconala.protobuf.gw.servicepr.PublishingInfo}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.getPublishingInfo = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.PublishingInfo} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.PublishingInfo, 2));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.PublishingInfo|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.setPublishingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.clearPublishingInfo = function() {
  return this.setPublishingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.hasPublishingInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value cpc = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.getCpc = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.setCpc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.clearCpc = function() {
  return this.setCpc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.hasCpc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Summary summary = 4;
 * @return {?proto.coconala.protobuf.gw.servicepr.Summary}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.getSummary = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.Summary} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.Summary, 4));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.Summary|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceSummary} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceSummary.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.ServiceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceId: (f = msg.getServiceId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    thumbnailUrl: (f = msg.getThumbnailUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    serviceKind: (f = msg.getServiceKind()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    masterCategoryName: (f = msg.getMasterCategoryName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.ServiceInfo;
  return proto.coconala.protobuf.gw.servicepr.ServiceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setServiceId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setThumbnailUrl(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServiceKind(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMasterCategoryName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.ServiceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getThumbnailUrl();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getServiceKind();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMasterCategoryName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value service_id = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getServiceId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setServiceId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearServiceId = function() {
  return this.setServiceId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasServiceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue title = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue thumbnail_url = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getThumbnailUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearThumbnailUrl = function() {
  return this.setThumbnailUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasThumbnailUrl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue service_kind = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getServiceKind = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setServiceKind = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearServiceKind = function() {
  return this.setServiceKind(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasServiceKind = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value price = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getPrice = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue master_category_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.getMasterCategoryName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.setMasterCategoryName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ServiceInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.clearMasterCategoryName = function() {
  return this.setMasterCategoryName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ServiceInfo.prototype.hasMasterCategoryName = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.PublishingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    publishingStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    disableReason: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.PublishingInfo;
  return proto.coconala.protobuf.gw.servicepr.PublishingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {!proto.coconala.protobuf.gw.servicepr.PublishingStatus} */ (reader.readEnum());
      msg.setPublishingStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.coconala.protobuf.gw.servicepr.DisableReason} */ (reader.readEnum());
      msg.setDisableReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.PublishingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPublishingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDisableReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.BoolValue enabled = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PublishingStatus publishing_status = 2;
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingStatus}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.getPublishingStatus = function() {
  return /** @type {!proto.coconala.protobuf.gw.servicepr.PublishingStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.coconala.protobuf.gw.servicepr.PublishingStatus} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.setPublishingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DisableReason disable_reason = 3;
 * @return {!proto.coconala.protobuf.gw.servicepr.DisableReason}
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.getDisableReason = function() {
  return /** @type {!proto.coconala.protobuf.gw.servicepr.DisableReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.coconala.protobuf.gw.servicepr.DisableReason} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PublishingInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.PublishingInfo.prototype.setDisableReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.ScreeningInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    servicesStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    profileImageEnabled: (f = msg.getProfileImageEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    identificationEnabled: (f = msg.getIdentificationEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    ndaEnabled: (f = msg.getNdaEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    restriction: (f = msg.getRestriction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.ScreeningInfo;
  return proto.coconala.protobuf.gw.servicepr.ScreeningInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.coconala.protobuf.gw.servicepr.ServicesStatus} */ (reader.readEnum());
      msg.setServicesStatus(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setProfileImageEnabled(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIdentificationEnabled(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setNdaEnabled(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setRestriction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.ScreeningInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServicesStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProfileImageEnabled();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIdentificationEnabled();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getNdaEnabled();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRestriction();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional ServicesStatus services_status = 1;
 * @return {!proto.coconala.protobuf.gw.servicepr.ServicesStatus}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.getServicesStatus = function() {
  return /** @type {!proto.coconala.protobuf.gw.servicepr.ServicesStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.coconala.protobuf.gw.servicepr.ServicesStatus} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.setServicesStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue profile_image_enabled = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.getProfileImageEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.setProfileImageEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.clearProfileImageEnabled = function() {
  return this.setProfileImageEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.hasProfileImageEnabled = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue identification_enabled = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.getIdentificationEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.setIdentificationEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.clearIdentificationEnabled = function() {
  return this.setIdentificationEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.hasIdentificationEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue nda_enabled = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.getNdaEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.setNdaEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.clearNdaEnabled = function() {
  return this.setNdaEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.hasNdaEnabled = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue restriction = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.getRestriction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.setRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.ScreeningInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.clearRestriction = function() {
  return this.setRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.ScreeningInfo.prototype.hasRestriction = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest;
  return proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue start_date = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue end_date = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csvPath: (f = msg.getCsvPath()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse;
  return proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCsvPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvPath();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue csv_path = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.getCsvPath = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.setCsvPath = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.clearCsvPath = function() {
  return this.setCsvPath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetDashboardCsvResponse.prototype.hasCsvPath = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.coconala.protobuf.gw.servicepr.PublishingStatus = {
  UNKNOWN_STATUS: 0,
  PUBLISHED: 1,
  STOPPED: 2
};

/**
 * @enum {number}
 */
proto.coconala.protobuf.gw.servicepr.ServicesStatus = {
  NOTHING_SERVICE: 0,
  OK: 1,
  NG: 2
};

/**
 * @enum {number}
 */
proto.coconala.protobuf.gw.servicepr.DisableReason = {
  UNKNOWN_REASON: 0,
  EXAMINATION_IN_PROGRESS: 1,
  EXAMINATION_NG: 2,
  NO_MONEY: 3,
  SERVICE_STOPPED: 4
};

goog.object.extend(exports, proto.coconala.protobuf.gw.servicepr);
